import { useState, useEffect } from "react";
import Noureldine from "@/public/images/Noureldine.png";
import Image from "next/image";
import PaidConsultation from "@/components/shared/ReservationSection/components/Paid Consultation/PaidConsultation";
import { useTranslate } from "@/components/base/providers/TranslateProv";

type Props = {};

export default function PopupMeassge({}: Props) {
  const [showMessage, setShowMessage] = useState(true);
  const { locale } = useTranslate();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showMessage) {
      timer = setTimeout(() => {
        setShowMessage(false);
      }, 20000);
    } else {
      timer = setTimeout(() => {
        setShowMessage(true);
      }, 60000);
    }

    return () => clearTimeout(timer);
  }, [showMessage]);

  const handleMessageClick = () => {
    setShowMessage(false);
  };

  return (
    <div
      className={`fixed z-[10] top-[75%] md:top-[85%] ${
        locale === "en" ? "right-[2%]" : "left-[2%]"
      }`}
      dir={locale === "en" ? "rtl" : "ltr"}
    >
      <div className="relative z-[101]">
        <PaidConsultation>
          <Image
            src={Noureldine}
            alt="Noureldine"
            className="w-[70px] h-[70px]"
          />
        </PaidConsultation>

        {showMessage && (
          <div
            className={`bg-[#465ff1] w-[220px] absolute p-[10px] rounded-[10px] -top-20 left-0 cursor-pointer
              
              ${
                locale === "ar"
                  ? "-top-20 left-0 text-start"
                  : "-top-32 right-0 text-end"
              }
              `}
            onClick={handleMessageClick}
          >
            <div className="grow shrink basis-0 text-sm w-fit  text-white font-normal font-['Somar Sans']">
              {locale === "ar"
                ? "تواصل مع سفير الجامعة لطلب استشارة ومساعدتك في التقديم والإجابة على جميع أسئلتك."
                : "Contact the university ambassador for consultation and assistance in applying and answering all your questions."}
            </div>
            <div
              className={`w-[10px] h-[10px] absolute -bottom-1 ${
                locale === "en" ? "right-3" : "left-3"
              } rotate-45 bg-[#465ff1]`}
            />
            <div
              className={`bg-[#ec4d4d] w-[14px] h-[14px] rounded-full absolute -top-[4px] shadow-lg shadow-[#e77979] ${
                locale === "en" ? "-left-[4px]" : " -right-[4px]"
              }`}
            />
          </div>
        )}
      </div>
    </div>
  );
}
